import { Themes } from "../constants/theme";

// Set Theme here 1/3 (React)
export const THEME: Themes = Themes.PF_CHRISTMAS;
